import { useMutation } from "@tanstack/react-query";
import Footer from "components/Footer";
import Header from "components/Header";
import TenantLogo from "components/TenantLogo";
import { ShopScreenProps } from "navigation/types";
import { useFetchFaqsQuery, useFetchShopPageQuery } from "queries/cms.queries";
import { trackConversion } from "queries/conversion.queries";
import { useFetchTenantBrandingQuery } from "queries/tenant.queries";
import React, { useEffect } from "react";
import ReactGA from "react-ga4";
import { View } from "react-native";
import Faqs from "./Faqs";
import HeroSection from "./HeroSection";
import Perks from "./Perks";
import Plans from "./Plans";
import Terms from "./Terms";

const Shop = ({ route, navigation }: ShopScreenProps) => {
  const { slug } = route.params;
  const { data: shopPage, isFetching: fetchingShopPage } =
    useFetchShopPageQuery({ slug });
  const { data: faqs, isFetching: fetchingFaqs } = useFetchFaqsQuery({ slug });
  const { data: branding } = useFetchTenantBrandingQuery();
  const { mutateAsync: track } = useMutation(trackConversion);

  useEffect(() => {
    async function init() {
      if (shopPage) {
        navigation.setOptions({ title: shopPage.name });
        ReactGA.send({ hitType: "pageview", page: shopPage.name });
        await track({ step: "PAGE_LOAD", flow: "SHOP_PHASE_ONE" });
      }
    }
    init();
  }, [shopPage]);

  if (fetchingFaqs || fetchingShopPage)
    return (
      <View className=" h-screen w-screen grid place-items-center">
        <View className="animate-bounce">
          <TenantLogo />
        </View>
      </View>
    );

  if (
    !shopPage ||
    faqs === null ||
    branding?.subdomain !== shopPage.subdomain
  ) {
    window.location.href = "/login";
    return null;
  }

  const hasFaqs = faqs !== undefined && faqs.length > 0;

  return (
    <View>
      {/* Header */}
      <Header programName={shopPage.name} showLogin />
      <HeroSection shopPage={shopPage} />
      <Plans shopPage={shopPage} />
      {shopPage.perks && <Perks shopPage={shopPage} hasFaqs={hasFaqs} />}
      {hasFaqs && <Faqs faqs={faqs} />}
      <Terms tenantSubdomain={shopPage.subdomain} />
      <Footer />
    </View>
  );
};

export default Shop;
